import global from './Globals';

export default {
  formHeaderText: global.black,
  formGroupText: global.primary,
  formGroupTextError: global.error,
  formGroupInput: global.black,
  formGroupInputActive: global.secondary,
  formGroupBorder: 'rgba(0, 0, 0, 0.25)',
  formGroupBorderError: global.error,
  formGroupBg: 'transparent',
  formGroupBgDisabled: global.grey200,
  formGroupFocusBorder: global.secondary,
  formGroupFocusGlow: global.primaryFade,
};
